import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import {fetchSystemGroupRangesById } from '@/services.ts';
import SystemConfigurationsList from '@/components/molecules/SystemConfigurationsList.tsx';
import {SYSTEMS_STALE_TIME_5_MINS} from '@/config';
import {LoadingScreen} from '@/components/molecules/LoadingScreen.tsx';
import {queryOptions, useSuspenseQuery} from '@tanstack/react-query';
import {ErrorComponent} from '@/components/molecules/ErrorComponent.tsx';
import { BackButton } from '@/components/atoms/BackButton';

const systemGroupRangesQueryOptions = (rangeId: string) => queryOptions({
  queryKey: ['systemGroups', 'ranges', rangeId],
  queryFn: () => fetchSystemGroupRangesById(rangeId),
  staleTime: SYSTEMS_STALE_TIME_5_MINS,
});

export const Route = createFileRoute('/systems/ranges/$rangeId/')({
  loader: async({ params, context }) => {
    const { rangeId } = params;
    return context.queryClient?.ensureQueryData(systemGroupRangesQueryOptions(rangeId));
  },
  component: SystemGroupRanges,
  pendingComponent: LoadingScreen
});

function SystemGroupRanges() {
  const { rangeId } = Route.useParams();
  const { error, data } = useSuspenseQuery(systemGroupRangesQueryOptions(rangeId));

  if(error) {
    return (<ErrorComponent error={error} />)
  }
  if(data) {
    if(data.models) {
      return (
        <div className="p-4">
          <BackButton />
          <h1 className="text-3xl font-bold mt-6">{data.name}</h1>
          { data.description }
          <SystemConfigurationsList systems={data.models} systemGroupId={data.systemGroupId} systemGroupRangeId={data._id} />
        </div>
      )
    }
    return (<div className="main-content"><h3>System Range not found.</h3></div>);
  }

}
